module.exports = __webpack_public_path__ + "static/media/bnp-paribas.0b5e03f2.svg";